import { render, staticRenderFns } from "./ryzzInner.vue?vue&type=template&id=0d51e184&scoped=true"
import script from "./ryzzInner.vue?vue&type=script&lang=js"
export * from "./ryzzInner.vue?vue&type=script&lang=js"
import style0 from "./ryzzInner.vue?vue&type=style&index=0&id=0d51e184&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d51e184",
  null
  
)

export default component.exports